module.exports = __webpack_public_path__ + "img/time_tracking.ebf72091.png";